import React, { useEffect, useMemo, useState } from 'react';
import Navbar from '../components/layout/Navbar';

export default function Snaps() {
  const rawBase = (process.env.REACT_APP_API_BASE || '').trim();
  const API_BASE = rawBase.replace(/^@+/, '') || '/dev';

  const [type, setType] = useState('matches');
  const [streams, setStreams] = useState([]);
  const [loadingStreams, setLoadingStreams] = useState(false);
  const [error, setError] = useState('');
  const [selectedStream, setSelectedStream] = useState('');
  const [snaps, setSnaps] = useState([]);
  const [loadingSnaps, setLoadingSnaps] = useState(false);

  const fetchStreams = async () => {
    setLoadingStreams(true);
    setError('');
    try {
      const res = await fetch(`${API_BASE}/media/snaps/streams?type=${encodeURIComponent(type)}&max=500`, { headers: { accept: 'application/json' } });
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const data = await res.json();
      const items = Array.isArray(data?.items) ? data.items : [];
      setStreams(items);
      if (!selectedStream && items.length > 0) setSelectedStream(items[0]);
    } catch (e) {
      setError('Failed to load streams');
    } finally {
      setLoadingStreams(false);
    }
  };

  const fetchSnaps = async (sid) => {
    if (!sid) return;
    setLoadingSnaps(true);
    setError('');
    try {
      const url = `${API_BASE}/media/snaps?type=${encodeURIComponent(type)}&stream_id=${encodeURIComponent(sid)}&max_keys=1000`;
      const res = await fetch(url, { headers: { accept: 'application/json' } });
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const data = await res.json();
      const items = Array.isArray(data?.items) ? data.items : [];
      setSnaps(items);
    } catch (e) {
      setError('Failed to load snaps');
    } finally {
      setLoadingSnaps(false);
    }
  };

  useEffect(() => {
    fetchStreams();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [type]);

  useEffect(() => {
    if (selectedStream) fetchSnaps(selectedStream);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedStream, type]);

  return (
    <div className="min-h-screen flex flex-col text-white pt-14 sm:pt-16">
      <Navbar />
      <main className="flex-1">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex items-center justify-between mb-4">
            <div className="text-lg font-bold">Snaps Browser</div>
            <div className="flex items-center gap-2">
              <label className="text-sm text-white/70">Type</label>
              <select value={type} onChange={(e) => setType(e.target.value)} className="px-2 py-1 rounded bg-white/10 border border-white/20 text-sm">
                <option value="matches">matches</option>
                <option value="tv">tv</option>
              </select>
            </div>
          </div>

          {error && <div className="mb-3 text-sm text-red-400 bg-red-900/20 border border-red-500/30 rounded p-2">{error}</div>}

          <div className="grid grid-cols-1 lg:grid-cols-4 gap-4">
            <div className="lg:col-span-1">
              <div className="rounded-xl border border-white/10 bg-white/5 p-3">
                <div className="flex items-center justify-between mb-2">
                  <div className="text-sm text-white/70">Streams</div>
                  {loadingStreams && <div className="text-[10px] text-white/60">Loading…</div>}
                </div>
                <div className="max-h-[60vh] overflow-auto divide-y divide-white/10">
                  {streams.length === 0 && <div className="text-xs text-white/60 py-2">No streams found</div>}
                  {streams.map((sid) => (
                    <button key={sid} type="button" onClick={() => setSelectedStream(sid)} className={`w-full text-left px-2 py-2 rounded ${selectedStream === sid ? 'bg-primary/30 border border-primary/40' : 'hover:bg-white/5'}`}>
                      <div className="text-xs font-semibold">{sid}</div>
                      <div className="text-[10px] text-white/60">{type}</div>
                    </button>
                  ))}
                </div>
              </div>
            </div>

            <div className="lg:col-span-3">
              <div className="flex items-center justify-between mb-2">
                <div className="text-sm text-white/70">{selectedStream ? `Snaps for ${selectedStream}` : 'Select a stream'}</div>
                {loadingSnaps && <div className="text-[10px] text-white/60">Loading…</div>}
              </div>
              <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-2">
                {snaps.map((s, idx) => (
                  <div key={idx} className="relative group rounded-lg overflow-hidden bg-white/5 border border-white/10">
                    <img src={s.url} alt={s.key} className="w-full h-full object-cover" loading="lazy" />
                    <div className="absolute inset-x-0 bottom-0 bg-black/50 text-[10px] p-1 truncate opacity-0 group-hover:opacity-100 transition-opacity">{s.key.split('/').slice(-1)[0]}</div>
                  </div>
                ))}
                {!loadingSnaps && snaps.length === 0 && (
                  <div className="text-xs text-white/60">No images for this stream.</div>
                )}
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}

